import BaseAPI from "./base";

const auth = {
  login(params) {
    return BaseAPI("post", "/Auth/Login", params);
  },
};

export default auth;
